export default function NavbarSeparator() {
  return (
    <div className="navbar-separator"></div>
  )
}